import { IApiError as ApiError } from "./onsip-api-action-new";

export interface ResourceState<T> {
  data: Record<string, T>;
  errors: Array<ApiError>;
  loading: boolean;
  loaded: boolean;
}

export function initialResourceState<T>(): ResourceState<T> {
  return { data: {}, errors: [], loading: false, loaded: false };
}
